import type { Dispatch, ReactChild, SetStateAction } from "react";
import { createContext, useContext, useState } from "react";
import { View } from "react-native";

interface ModalContext {
  setIsVisible: Dispatch<SetStateAction<boolean>>;
  setContentComponent: Dispatch<SetStateAction<ReactChild | null>>;
}

const ModalContext = createContext<ModalContext>({
  setIsVisible: () => {},
  setContentComponent: () => null,
});

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }: { children: ReactChild }) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [contentComponent, setContentComponent] =
    useState<React.ReactChild | null>(null);

  return (
    <ModalContext.Provider value={{ setIsVisible, setContentComponent }}>
      {isVisible ? (
        <View
          style={{
            padding: 48,
            width: "100%",
            height: "100vh",
            overflow: "hidden",
          }}
        >
          {contentComponent}
        </View>
      ) : null}
      {children}
    </ModalContext.Provider>
  );
};
